import React from "react";
import { useState, useEffect, useContext } from "react";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { Context } from "../../../context/UserContext";
import CompanyService from "../../../services/CompanyService"
import ChangePasswordModal from "../../modals/ChangePasswordModal";

import api from "../../../utils/api";
import { ehUsuarioInterno } from "../../../utils/roles";

export default function Profile() {

  const { user: userContext ,setUser: setUserContext, authenticated } = useContext(Context);

  const estados = [
    { nome: "Acre", sigla: "AC" },
    { nome: "Alagoas", sigla: "AL" },
    { nome: "Amapá", sigla: "AP" },
    { nome: "Amazonas", sigla: "AM" },
    { nome: "Bahia", sigla: "BA" },
    { nome: "Ceará", sigla: "CE" },
    { nome: "Distrito Federal", sigla: "DF" },
    { nome: "Espírito Santo", sigla: "ES" },
    { nome: "Goiás", sigla: "GO" },
    { nome: "Maranhão", sigla: "MA" },
    { nome: "Mato Grosso", sigla: "MT" },
    { nome: "Mato Grosso do Sul", sigla: "MS" },
    { nome: "Minas Gerais", sigla: "MG" },
    { nome: "Pará", sigla: "PA" },
    { nome: "Paraíba", sigla: "PB" },
    { nome: "Paraná", sigla: "PR" },
    { nome: "Pernambuco", sigla: "PE" },
    { nome: "Piauí", sigla: "PI" },
    { nome: "Rio de Janeiro", sigla: "RJ" },
    { nome: "Rio Grande do Norte", sigla: "RN" },
    { nome: "Rio Grande do Sul", sigla: "RS" },
    { nome: "Rondônia", sigla: "RO" },
    { nome: "Roraima", sigla: "RR" },
    { nome: "Santa Catarina", sigla: "SC" },
    { nome: "São Paulo", sigla: "SP" },
    { nome: "Sergipe", sigla: "SE" },
    { nome: "Tocantins", sigla: "TO" },
  ];

  const [user, setUser] = useState({});
  const [token] = useState(localStorage.getItem("token") || "");
  const [preview, setPreview] = useState();
  const [companiesList, setCompaniesList] = useState([])
  const [changePasswModal, setChangePasswModal] = useState(false)

  function onFileChange(e) {
    setPreview(e.target.files[0]);
    // setUser({ ...user, [e.target.name]: e.target.files[0] })
  }

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue, // Função do react-hook-form para definir valores
    reset,
  } = useForm();

  useEffect(() => {
    if (authenticated) {
      const fetchCompanies = async () => {
        const result = await CompanyService.getCompanies();
        setCompaniesList(result.companies)
      }
      fetchCompanies();

      // Após receber os dados do usuário, atualize os valores do formulário usando setValue
      Object.keys(user).forEach((key) => {
        if (key === 'company') {
          setValue(key, user.company._id)
        } else {
          setValue(key, user[key]);
        }
      });
    }
    
  }, [user, setValue, authenticated]);

  useEffect(() => {
    api
      .get("/users/checkuser", {
        headers: {
          Authorization: `Bearer ${JSON.parse(token)}`,
        },
      })
      .then((response) => {
        setUser(response.data);
        // console.log(response.data);
      });
    // console.log(user);
  }, [token]);

  

  //   function onFileChange(e) {}

  const validateEmail = (value) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(value);
  };

  //   const onSubmit = (data) => {
  //     console.log(data);
  //     // createUser(data)
  //   };

  const removePicture = async () => {
    try {

      const body= { "image":"" }

      const response = await api.patch(`/users/edit/${user._id}`, body, {
        headers: {
          Authorization: `Bearer ${JSON.parse(token)}`,
          "Content-Type": "application/json",
        },
      });
      reset({image: "" })
      setPreview()
      setUserContext(response.data.data);

      toast.success("Foto removida!", {
        // position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      
      
    } catch (err) {
      console.error(err);
      // Trate o erro conforme necessário

      toast.error("Ops! " + err.response.data.message, {
        // position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });

      return err.response.data;
    }
  }

  const onSubmit = async (data) => {
    // e.preventDefault()

    const formData = new FormData();

    // Adicione cada campo do objeto data ao formData
    await Object.keys(data).forEach((key) => {
      // Se o campo é um arquivo, adicione-o separadamente ao FormData
      if (data[key] instanceof FileList) {
        formData.append(key, data[key][0]); // Assumindo que você está permitindo apenas um arquivo
      } else {
        formData.append(key, data[key]);
      }
    });

    // console.log(formData);

    try {
      // Faça a requisição PATCH usando formData para incluir a imagem
      const response = await api.patch(`/users/edit/${user._id}`, formData, {
        headers: {
          Authorization: `Bearer ${JSON.parse(token)}`,
          "Content-Type": "multipart/form-data",
        },
      });

      // console.log(response.data.data);

      toast.success("Usuário atualizado!", {
        // position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });

      setUserContext(response.data.data);

      
      // user.image = userContext.image

      window.location.reload();
      return response.data;
      
    } catch (err) {
      console.error(err);
      // Trate o erro conforme necessário

      toast.error("Ops! " + err.response.data.message, {
        // position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });

      return err.response.data;
    }
  };

  return (
    <div className="flex w-full h-full justify-center items-center gap-4 py-4 px-6 bg-gray-200">
      {/* LEFT */}
      <div className='flex flex-col w-2/6 h-full gap-2 rounded-xl p-4 bg-white'>
        
        <div className="text-3xl font-bold mt-4">{user.name}</div>

        <div className="border border-t-1 border-zinc-100"></div>

        {/* {(user.image || user.image === "" || preview) && ( */}
          <div className="flex flex-col bg-white justify-center items-center mt-4 mb-2 py-4">
            <img
              src={
                preview
                  ? URL.createObjectURL(preview)
                  : (!userContext.image || userContext.image === "")
                  ? `${process.env.REACT_APP_API}/images/users/user.jpg`
                  : `${process.env.REACT_APP_API}/images/users/${userContext.image}`
              }
              alt={user.name}
              className="h-40 w-40 object-cover rounded-full"
            />
            
            <button
              disabled={!userContext.image || userContext.image===""}
              onClick={removePicture}
              className={`flex w-40 justify-center rounded-2xl bg-indigo-400 px-3 my-2 text-sm font-semibold leading-6 
                            text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2
                            focus-visible:outline-offset-2 focus-visible:outline-indigo-600
                             disabled:bg-gray-300`}
            >
              Remover Foto
            </button>
            
          </div>
        {/* )} */}
        
        
        <input
          {...register("image")}
          text="Imagem"
          type="file"
          name="image"
          onChange={onFileChange}
          className="text-sm text-stone-500 border border-zinc-400 rounded-2xl
            py-2 px-2
            file:mr-5 file:py-1 file:px-3 file:border-0 file:rounded-2xl
            file:text-xs file:font-semibold
            file:bg-indigo-400 file:text-white
            hover:file:cursor-pointer hover:file:bg-indigo-500"
        />
      </div>
      

      {/* RIGHT */}

      <div className='flex flex-col w-full min-h-full rounded-xl py-8 px-6 gap-12 bg-white'>
        <div className="flex justify-center text-3xl font-semibold whitespace-nowrap">
          Editar Perfil
        </div>

        <div className="min-w-96 flex flex-col gap-3">
          <div className="flex items-center justify-between gap-2">
            <label className="w-1/4 block text-sm font-medium text-gray-900">
              Nome:
            </label>
            <div className="w-full">
              <input
                {...register("name", { required: true })}
                placeholder="Digite seu nome"
                type="text"
                className={`block w-full rounded-2xl px-4 py-1 text-gray-900 shadow-sm placeholder:text-gray-400
                    ${
                      errors?.name?.type === "required"
                        ? " border border-red-500 outline-none ring-0"
                        : "border border-zinc-500 outline-none ring-0"
                    }
                    `}
              />
              {errors?.name?.type === "required" && (
                <p className="text-red-500 text-xs ms-2">Nome é obrigatório</p>
              )}
            </div>
          </div>

          <div className="flex items-center justify-between gap-2">
            <label className="w-1/4 block text-sm font-medium text-gray-900">
              Email
            </label>
            <div className="w-full">
              <input
                {...register("email", {
                  required: true,
                  validate: (value) => {
                    return validateEmail(value);
                  },
                })}
                placeholder="Digite seu email"
                type="email"
                autoComplete="email"
                required
                className={`block w-full rounded-2xl px-4 py-1 text-gray-900 shadow-sm placeholder:text-gray-400
                    ${
                      errors?.email?.type === "required"
                        ? " border border-red-500 outline-none ring-0"
                        : "border border-zinc-500 outline-none ring-0"
                    }
                    `}
              />
              {errors?.email?.type === "required" && (
                <p className="text-red-500 text-xs ms-2">Email é obrigatório</p>
              )}
              {errors?.email?.type === "validate" && (
                <p className="text-red-500 text-xs ms-2">
                  Digite um email válido
                </p>
              )}
            </div>
          </div>

          <div className="flex items-center justify-between gap-2">
            <label className="w-1/4 block text-sm font-medium text-gray-900">
              Telefone
            </label>
            <div className="w-full">
              <input
                {...register("phone", { required: true })}
                placeholder="Digite seu telefone"
                type="text"
                required
                className={`block w-full rounded-2xl px-4 py-1 text-gray-900 shadow-sm placeholder:text-gray-400
                    ${
                      errors?.phone?.type === "required"
                        ? " border border-red-500 outline-none ring-0"
                        : "border border-zinc-500 outline-none ring-0"
                    }
                    `}
              />
              {errors?.phone?.type === "required" && (
                <p className="text-red-500 text-xs ms-2">
                  Telefone é obrigatório
                </p>
              )}
            </div>
          </div>

          <div className="flex items-center justify-between gap-2">
            <label className="w-1/4 block text-sm font-medium text-gray-900 whitespace-nowrap">
              RE / LEGAL
            </label>
            <div className="w-full">
              <input
                {...register("reLegal")}
                placeholder="Digite seu código legal"
                type="text"
                required
                className={`block w-full rounded-2xl px-4 py-1 text-gray-900 shadow-sm placeholder:text-gray-400
                    ${
                      errors?.reLegal?.type === "required"
                        ? " border border-red-500 outline-none ring-0"
                        : "border border-zinc-500 outline-none ring-0"
                    }
                    `}
              />
            </div>
          </div>

          <div className="flex items-center justify-between gap-2">
            <label className="w-1/4 block text-sm font-medium text-gray-900">
              Estado:
            </label>
            <div className="w-full">
              <select
                defaultValue="0"
                {...register("uf", {
                  validate: (value) => {
                    return value !== "0";
                  },
                })}
                className={`block w-full rounded-2xl px-4 py-1 text-gray-900 shadow-sm placeholder:text-gray-400
                  ${
                    errors?.uf?.type === "validate"
                      ? " border border-red-500 outline-none ring-0"
                      : "border border-zinc-500 outline-none ring-0"
                  }
                  `}
              >
                <option value="0" disabled>
                  Escolha um estado
                </option>
                {estados.map((estado, index) => (
                  <option key={index} value={estado.sigla}>
                    {estado.nome}
                  </option>
                ))}
              </select>
              {errors?.uf?.type === "validate" && (
                <p className="text-red-500 text-xs ms-2">
                  Estado é obrigatório
                </p>
              )}
            </div>
          </div>

          <div className="flex items-center justify-between gap-2">
            <label className="w-1/4 block text-sm font-medium text-gray-900">
              Perfil:
            </label>
            <div className="w-full">
              <select
                disabled = { !ehUsuarioInterno(user) }
                {...register("role")}
                className="block w-full rounded-2xl px-4 py-1 text-gray-900 shadow-sm placeholder:text-gray-400 border border-zinc-500 outline-none ring-0"
              >
                <option value="user">Usuário</option>
                <option value="tecnico">Técnico</option>
                <option value="warehouse">Warehouse</option>
                <option value="vivogestao">Vivo Gestão</option>
              </select>
            </div>
          </div>

          <div className="flex items-center justify-between gap-2">
            <label className="w-1/4 block text-sm font-medium text-gray-900 whitespace-nowrap">
              Empresa:
            </label>
            <div className="w-full">
              <select
                // defaultValue="telefonica"
                {...register("company")}
                className="block w-full rounded-2xl px-4 py-1 text-gray-900 shadow-sm placeholder:text-gray-400 border border-zinc-500 outline-none ring-0"
              >
                {/* <option value="telefonica">TELEFONICA BRASIL S.A.</option> */}
                {companiesList.map((company) => (
                  <option key={company._id} value={company._id}>
                    {company.name}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className="flex items-center justify-between gap-2">
            <label className="w-1/4 block text-sm font-medium text-gray-900 whitespace-nowrap">
              Senha:
            </label>
            <div className="w-full">
              <button
                onClick={() => setChangePasswModal(true)}
                className="flex w-80 justify-center rounded-2xl bg-yellow-400 px-3 py-1 text-sm leading-6 text-black shadow-sm hover:bg-yellow-300 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-yellow-400"
                >
                Trocar Senha
              </button>
            </div>
          </div>

        </div>
        <div className="w-full flex flex-col gap-3 justify-center items-center my-6">
          <button
            onClick={() => handleSubmit(onSubmit)()}
            className="flex w-80 justify-center rounded-2xl bg-indigo-600 px-3 py-1 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
          >
            Salvar
          </button>
        </div>
      </div>

      <div className="absolute">
        <ChangePasswordModal
          isModalOpen={changePasswModal}
          setModalOpen={() => {
            setChangePasswModal(!changePasswModal);
          }}
        ></ChangePasswordModal>
      </div>
      
    </div>
  );
}
